<script lang="ts">
	import { createEventDispatcher, onMount } from "svelte";
	import { fade } from "svelte/transition";

	const dispatch = createEventDispatcher();

	export let disabled = false;
	export let roundedNone = false;
	export let bgClass = "",
		outerClass = "";

	let isOpen = false;

	export function open() {
		isOpen = true;
		// Compensa a largura da scrollbar para o conteúdo não "pular" ao travar o scroll.
		const scrollbarWidth =
			window.innerWidth - document.documentElement.clientWidth;
		document.body.style.overflow = "hidden";
		if (scrollbarWidth > 0) {
			document.body.style.paddingRight = `${scrollbarWidth}px`;
		}
	}
	export function close() {
		isOpen = false;
		document.body.style.overflow = "";
		document.body.style.paddingRight = "";
		dispatch("close");
	}

	let modal: HTMLDivElement;

	onMount(() => {
		return () => {
			document.body.style.overflow = "";
			document.body.style.paddingRight = "";
		};
	});
</script>

{#if isOpen}
	<div>
		<button
			id="modal-background"
			class={bgClass +
				" fixed left-0 top-0 z-[100] h-screen w-screen bg-black opacity-40"}
			{disabled}
			on:click={() => close()}
			transition:fade|local={{ duration: 200 }}
		/>

		<div
			class="pointer-events-none fixed left-0 top-0 z-[101] flex h-screen w-screen items-center justify-center"
			transition:fade|local={{ duration: 200 }}
		>
			<div
				bind:this={modal}
				id="modal"
				class={outerClass +
					` flex ${roundedNone ? "" : "md:rounded-[53px]"} pointer-events-auto bg-white`}
			>
				<slot />
			</div>
		</div>
	</div>
{/if}

<style>
	#modal {
		box-shadow: 7px 10px 20px rgba(0, 0, 0, 0.25);
	}
</style>
